'use client';

import React from 'react';
import Link from 'next/link';

type Props = {
  title: string;
  href?: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

export default function DashboardMetricCard({ title, href, icon, children, className }: Props) {
  const interactive = !!href;
  const tile = (
    <div
      className={
        'h-full rounded-2xl border border-border bg-card p-4 sm:p-5 transition-all duration-200 ' +
        (interactive ? 'hover:shadow-md hover:-translate-y-0.5 hover:border-primary/30 ' : '') +
        (className || '')
      }
    >
      <div className="flex items-center gap-2.5 mb-3">
        {icon ? (
          <span className="ring-chip inline-grid h-8 w-8 place-items-center rounded-lg">{icon}</span>
        ) : null}
        <h2 className="text-sm font-medium text-foreground/70">{title}</h2>
      </div>
      {children}
    </div>
  );

  return href ? (
    <Link href={href} className="block rounded-2xl outline-none focus-visible:ring-2 focus-visible:ring-ring">
      {tile}
    </Link>
  ) : (
    tile
  );
}
